import { render, staticRenderFns } from "./KpiSide.vue?vue&type=template&id=b1c35452&scoped=true&"
import script from "./KpiSide.vue?vue&type=script&lang=js&"
export * from "./KpiSide.vue?vue&type=script&lang=js&"
import style0 from "./KpiSide.vue?vue&type=style&index=0&id=b1c35452&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c35452",
  null
  
)

export default component.exports